import { Quote, Star } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { Reveal, SectionHead } from "./Reveal";

export default function Reviews() {
  const { reviews: REVIEWS } = useSite();
  if (!REVIEWS.length) return null;
  return (
    <section id="yorumlar" className="relative bg-[#0d0b3d] py-24 md:py-36" data-testid="reviews-section">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHead kicker="Müşteri Yorumları" title={<>Dolunay'da<br />izleyenler.</>} testid="reviews-title" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {REVIEWS.map((r, i) => (
            <Reveal key={i} delay={i * 0.1} className="h-full">
              <figure className="h-full flex flex-col rounded-[28px] border border-white/10 bg-[#13114f] p-8" data-testid={`review-card-${i}`}>
                <Quote size={32} className="text-[#8a8dff]" />
                <blockquote className="mt-6 flex-1 text-lg leading-relaxed text-white">{r.text}</blockquote>
                <div className="mt-6 flex gap-1 text-[#8a8dff]">
                  {[0, 1, 2, 3, 4].map((s) => <Star key={s} size={16} fill="currentColor" />)}
                </div>
                <figcaption className="mt-4 border-t border-white/10 pt-4">
                  <p className="font-display font-semibold">{r.name}</p>
                  <p className="text-sm text-[#c9c6f0]">{r.city}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
